module.exports = __webpack_public_path__ + "media/פרח.23cfd53d.mp3";